export default class User {
id = ''
alias = ''
name = ''
email = ''
intercom = ''
picture = ''
}
